import commitMutation from 'relay-commit-mutation-promise';
import { graphql } from 'react-relay/legacy';

import { executeCaptcha } from 'dibs-recaptcha/exports/recaptcha';

const mutation = graphql`
    mutation sendMessageMutation($input: ContactDealerInput!) {
        contactDealer(input: $input) {
            conversation {
                id
            }
        }
    }
`;

export async function sendMessageMutation({
    action,
    buyerId,
    displayName,
    environment,
    itemPk,
    messageContent,
    pageContext,
    sellerPk,
    enableCaptcha,
}) {
    let captchaResults;

    if (enableCaptcha) {
        captchaResults = await executeCaptcha({
            action: 'contactDealer',
            featureFlag: 'contactDealerCaptcha',
            relayEnvironment: environment,
        });
    }

    const input = {
        action,
        buyerId,
        displayName,
        itemPk,
        messageContent,
        pageContext,
        sellerPk,
        captchaToken: captchaResults?.captchaToken,
    };

    return commitMutation(environment, {
        mutation,
        variables: { input },
    });
}
